export interface IDatePickerModel {
  date: Date;
  isCurrentMonth: boolean;
  text: string;
}
